import type { ThemeOptions } from '@mui/material/styles';

export const typography: ThemeOptions['typography'] = {
    fontFamily: 'IRANSans',
};